module.exports = {
	"articleTitle1": "North Campus buildings closed after pipes bust",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Dow Engineering Building (DOW)",
	"articleLink1": "https://www.michigandaily.com/content/north-campus-buildings-closed-after-pipes-bust",
	"articleLink2": "https://www.michigandaily.com/section/news/regents-recap",
	"articleSnippet1": "Oct 29, 2003 ... 'U' shuts down Media Union, other buildings last night, but says classes ... \nbuilding closures and dismaying overworked Engineering students.",
	"articleSnippet2": "May 18, 2017 ... ... provost of biosciences, and an extension of the Dow Sustainability Fund. ... \naddition to improve connectivity between the buildings, among other things. ... in \nthe Department of Civil and Environmental Engineering and the ...",
	"totalMisc": 0,
	"articleTitle2": "Regents recognize faculty and approve continued sustainability ...",
	"address": "2300 Hayward St. Ann Arbor, MI",
	"images": [],
	"position": {
		"lat": 42.292997,
		"lng": -83.715452
	},
	"tips": [
		{
			"text": "The classrooms in DOW are good places to study when there are no classes going on.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 2,
			"bathroom": "1st Floor"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/dowbuilding.json
// module id = 865
// module chunks = 0